<div class="images-container">
  <!-- Mensaje de error -->
  <div *ngIf="errorMessage" class="error-message">
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="8" x2="12" y2="12"></line>
      <line x1="12" y1="16" x2="12.01" y2="16"></line>
    </svg>
    {{ errorMessage }}
  </div>

  <!-- Loading -->
  <div *ngIf="isLoading" class="loading-container">
    <div class="spinner"></div>
    <p>Cargando imagen...</p>
  </div>

  <!-- Vista de imagen seleccionada (si viene desde el sidebar) -->
  <div *ngIf="!isLoading && !errorMessage && imagenSeleccionada" class="single-image-view">
    <div class="image-viewer-full">
      <img [src]="imagenSeleccionada.url_image" [alt]="getImageName(imagenSeleccionada.url_image)" />
    </div>
    <div class="image-info-full">
      <p class="image-title">{{ getImageName(imagenSeleccionada.url_image) }}</p>
      <div class="image-actions">
        <button (click)="descargarImagen(imagenSeleccionada.url_image)" class="download-button" title="Descargar imagen">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
            <polyline points="7 10 12 15 17 10"></polyline>
            <line x1="12" y1="15" x2="12" y2="3"></line>
          </svg>
          Descargar
        </button>
        <a [href]="imagenSeleccionada.url_image" target="_blank" class="image-link">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
            <polyline points="15 3 21 3 21 9"></polyline>
            <line x1="10" y1="14" x2="21" y2="3"></line>
          </svg>
          Abrir en nueva pestaña
        </a>
      </div>
    </div>
  </div>

  <!-- Vista de lista de imágenes (si no hay imagenId en la URL) -->
  <div *ngIf="!isLoading && !errorMessage && !imagenSeleccionada" class="images-list-view">
    <div class="images-header">
      <h1>Mis Imágenes</h1>
      <p class="images-subtitle">Imágenes que has cargado en el procesador</p>
    </div>

    <div *ngIf="imagenes.length === 0" class="empty-state">
      <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
        <circle cx="8.5" cy="8.5" r="1.5"></circle>
        <polyline points="21 15 16 10 5 21"></polyline>
      </svg>
      <p>No tienes imágenes cargadas aún</p>
      <p class="empty-state-subtitle">Sube imágenes en el procesador de imágenes para verlas aquí</p>
    </div>

    <div *ngIf="imagenes.length > 0" class="images-grid">
      <div 
        *ngFor="let imagen of imagenes" 
        class="image-item"
        (click)="seleccionarImagen(imagen.id)"
      >
        <div class="image-thumbnail">
          <img [src]="imagen.url_image" [alt]="getImageName(imagen.url_image)" />
          <div class="image-overlay">
            <div class="overlay-actions">
              <button (click)="descargarImagen(imagen.url_image, $event)" class="overlay-download-btn" title="Descargar imagen">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                  <polyline points="7 10 12 15 17 10"></polyline>
                  <line x1="12" y1="15" x2="12" y2="3"></line>
                </svg>
              </button>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
            </div>
          </div>
        </div>
        <p class="image-name">{{ getImageName(imagen.url_image) }}</p>
      </div>
    </div>
  </div>
</div>
